(function(){
  'use strict';

  var burger   = document.getElementById('nav-burger');
  var menu     = document.getElementById('mobile-menu');
  var overlay  = document.getElementById('mobile-menu-overlay');
  var closeBtn = document.getElementById('mobile-menu-close');

  function openMenu(){
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if(burger) burger.setAttribute('aria-expanded','true');
  }

  function closeMenu(){
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if(burger) burger.setAttribute('aria-expanded','false');
  }

  if(burger)   burger.addEventListener('click', openMenu);
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  if(overlay)  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeMenu();
  });
})();
